import { fetchApi } from '@/config/axiosSetting';
import {
  GetBankAccountQueryParamsType,
  GetBankAccountQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getBankAccount/getBankAccountQuery.type';

export const getBankAccountFunction = (
  params: GetBankAccountQueryParamsType,
): Promise<GetBankAccountQueryResponseType> => {
  return fetchApi.get(
    `/property/reports/${params.id}/accident_users/damaged/bank_information/`,
    { params: { damaged_id: params?.damaged_id } },
  );
};
